import { ColDef, ColGroupDef } from 'ag-grid';

export function viewEditExists(columnDefs: (ColDef | ColGroupDef)[]): boolean {
  let exists = false;
  columnDefs.some((def) => {
    if (def.headerName === 'View/Edit') {
      exists = true;
      return true;
    }
  });
  return exists;
}
